<mat-form-field  floatLabel=never>
  <mat-label>Kunde</mat-label>
  <mat-select [(value)]="selectedCustomer"  [compareWith]="compareObjects"  (selectionChange)="onCustomerSelection(selectedCustomer)" >
      <mat-option *ngFor="let customer of customers" [value]="customer">
      {{customer.name}}
      </mat-option>
  </mat-select>
</mat-form-field>
